import {createSlice } from '@reduxjs/toolkit'

const RevenueModuleSlice = createSlice({
    name: "RevenueModuleSlice",
    initialState: {
        activeComponent: null,
        selectedCity: null,
        selectedMonth: null,
        logs: null,
    },
    reducers: {
       setActiveComponent(state, actions){
            state.activeComponent = actions.payload;
       },
       clearRevenueModule(state){
            state.activeComponent = null;
            state.selectedCity = null;
            state.selectedMonth = null;
            state.logs = null;
       },
       selectCityRM(state, actions){
            state.selectedCity = actions.payload;
       },
       selectMonthRM(state, actions){
            state.selectedMonth = actions.payload;
       },
       setLogs(state, actions){
          state.logs = actions.payload;
       },
    }
})

export default RevenueModuleSlice.reducer
export const { setActiveComponent, clearRevenueModule, selectCityRM, selectMonthRM, setLogs } = RevenueModuleSlice.actions